module.exports = {
      id: "symbol-close-circle-usage",
      viewBox: "0 0 27.965 27.965",
      url: __webpack_public_path__ + "media/sprite.9e429753.svg#symbol-close-circle-usage",
      toString: function () {
        return this.url;
      }
    }